import { Button, Card, Group, Image, Loader, Stack, Text, TextInput, Title } from "@mantine/core";
import React, { useState } from "react";
import { useGetAppadminGraphProfilePhotoQuery } from "../../../../openapi";

export const GraphProfilePhotoTest: React.FC = () => {
  const [inputValue, setInputValue] = useState("");
  const [submittedUserId, setSubmittedUserId] = useState<string | null>(null);

  const {
    data: profilePhoto,
    isFetching,
    isError,
  } = useGetAppadminGraphProfilePhotoQuery(
    { userIdOrPrincipalName: submittedUserId ?? "" },
    { skip: submittedUserId == null },
  );

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    const trimmedValue = inputValue.trim();
    if (!trimmedValue) return;
    setSubmittedUserId(trimmedValue);
  };

  return (
    <Card withBorder shadow="sm" p="md">
      <Stack gap="sm">
        <Group justify="space-between" align="center">
          <Title order={3}>Graph profilbilde-test</Title>
          {isFetching && <Loader size="sm" />}
        </Group>

        <form onSubmit={handleSubmit}>
          <Group align="end" gap="sm">
            <TextInput
              label="Azure object id eller e-post"
              placeholder="perst@multiconsult.no"
              value={inputValue}
              onChange={(event) => setInputValue(event.currentTarget.value)}
              style={{ flex: 1 }}
            />
            <Button type="submit" loading={isFetching}>
              Hent bilde
            </Button>
          </Group>
        </form>

        {isError && (
          <Text size="sm" c="red">
            Klarte ikke hente profilbilde fra Graph.
          </Text>
        )}

        {profilePhoto?.found === false && profilePhoto.errorMessage && (
          <Text size="sm" c="dimmed">
            {profilePhoto.errorCode}: {profilePhoto.errorMessage}
          </Text>
        )}

        {profilePhoto?.dataUrl && (
          <Group gap="sm" align="center">
            <Image src={profilePhoto.dataUrl} alt="Profilbilde fra Graph" w={96} h={96} radius="xl" />
            <Stack gap={2}>
              <Text size="sm" fw={500}>
                {profilePhoto.userIdOrPrincipalName}
              </Text>
              <Text size="xs" c="dimmed">
                {profilePhoto.contentType}
              </Text>
            </Stack>
          </Group>
        )}
      </Stack>
    </Card>
  );
};
